import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "page-bar" }
const _hoisted_3 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_4 = { class: "form-wrapper template-page-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "template-empty"
}
const _hoisted_6 = {
  key: 0,
  class: "template-empty"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "template-item-summary" }
const _hoisted_9 = { class: "template-item-name" }
const _hoisted_10 = {
  key: 0,
  class: "template-default-pill"
}
const _hoisted_11 = { class: "template-item-cols" }
const _hoisted_12 = { class: "template-item-head-right" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "template-item-body"
}
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = { class: "template-sec-fields" }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = { class: "template-col-links" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { style: {"display":"flex"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Playbook"),
        _createElementVNode("div", { class: "page-bar-main" }, "Role Sheet Templates")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-light",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, "Back")
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      _createElementVNode("div", _hoisted_4, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { style: {"margin-bottom":"20px"} }, " Templates show up when someone adds a role sheet. Picking one starts the sheet with these sections, which can still be changed on the sheet afterwards. A section's hint shows under it while the sheet is being edited, to say what belongs there. The default template is what new sheets start with unless another is picked. With no default set, they get the standard sections. ", -1)),
        (!_ctx.canManage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Only Playbook Admins can manage role sheet templates."))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (!_ctx.templates.length && !_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, "No templates yet. Add one below."))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templates, (t, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: t.ID || `new-${i}`,
                  class: "template-item"
                }, [
                  _createElementVNode("div", {
                    class: "template-item-head",
                    onClick: ($event: any) => (_ctx.toggleOpen(i))
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, [
                        _createTextVNode(_toDisplayString(t.Name || '(untitled template)'), 1),
                        (t.IsDefault)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Default"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.Sections, (s, si) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: si,
                            class: "template-col-chip"
                          }, _toDisplayString(s.label), 1))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      (t.ID && !t.IsDefault)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "template-make-default",
                            onClick: _withModifiers(($event: any) => (_ctx.setDefault(t)), ["stop"])
                          }, "Make Default", 8, _hoisted_13))
                        : _createCommentVNode("", true),
                      (_openBlock(), _createElementBlock("svg", {
                        onClick: _withModifiers(($event: any) => (_ctx.onDeleteTemplateClick(t)), ["stop"]),
                        class: "template-delete-icon",
                        fill: "currentColor",
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "18",
                        height: "18",
                        viewBox: "0 0 24 24"
                      }, [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("path", { d: "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.538l-4.592-4.548 4.546-4.587-1.416-1.403-4.545 4.589-4.588-4.543-1.405 1.405 4.593 4.552-4.547 4.592 1.405 1.405 4.555-4.596 4.591 4.55 1.403-1.416z" }, null, -1)
                      ]))], 8, _hoisted_14)),
                      _createElementVNode("span", {
                        class: _normalizeClass(["template-chevron", _ctx.openIndex == i ? 'open' : ''])
                      }, "▸", 2)
                    ])
                  ], 8, _hoisted_7),
                  (_ctx.openIndex == i)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _cache[7] || (_cache[7] = _createElementVNode("h3", {
                          class: "template-label",
                          style: {"margin-top":"0"}
                        }, "Template name", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": ($event: any) => ((t.Name) = $event),
                          placeholder: "Template name"
                        }, null, 8, _hoisted_16), [
                          [_vModelText, t.Name]
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "template-label" }, "Description", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": ($event: any) => ((t.Description) = $event),
                          placeholder: "Shown when picking a template for a new sheet"
                        }, null, 8, _hoisted_17), [
                          [_vModelText, t.Description]
                        ]),
                        _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "template-label" }, [
                          _createTextVNode("Sections "),
                          _createElementVNode("span", { class: "template-hint" }, "(drag to reorder; hints are optional)")
                        ], -1)),
                        _createVNode(_component_draggable, {
                          modelValue: t.Sections,
                          "onUpdate:modelValue": ($event: any) => ((t.Sections) = $event),
                          handle: ".template-col-handle"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.Sections, (s, si) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: si,
                                class: "template-sec-row"
                              }, [
                                _cache[6] || (_cache[6] = _createElementVNode("span", {
                                  class: "template-col-handle",
                                  title: "Drag to reorder"
                                }, "⋮⋮", -1)),
                                _createElementVNode("div", _hoisted_18, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((s.label) = $event),
                                    placeholder: "Section name"
                                  }, null, 8, _hoisted_19), [
                                    [_vModelText, s.label]
                                  ]),
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": ($event: any) => ((s.hint) = $event),
                                    rows: "2",
                                    maxlength: "500",
                                    placeholder: "Hint: what belongs in this section, like \"3 to 5 numbers checked every week, with targets\""
                                  }, null, 8, _hoisted_20), [
                                    [_vModelText, s.hint]
                                  ])
                                ]),
                                _createVNode(_component_svg_icon, {
                                  icon: "x",
                                  class: "template-remove",
                                  onClick: ($event: any) => (t.Sections.splice(si, 1))
                                }, null, 8, ["onClick"])
                              ]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("span", {
                            class: "template-addlink",
                            onClick: ($event: any) => (t.Sections.push({ label: '', hint: '' }))
                          }, "+ Add Section", 8, _hoisted_22)
                        ]),
                        _createElementVNode("input", {
                          class: _normalizeClass(t._saving ? 'disable-button' : ''),
                          type: "submit",
                          value: "Save Template",
                          onClick: ($event: any) => (_ctx.saveTemplate(t))
                        }, null, 10, _hoisted_23)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", {
                  class: "add-btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addTemplate()))
                }, "+ Add Template")
              ])
            ], 64))
      ])
    ], 2),
    (_ctx.templatePendingDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 0,
          onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteTemplateConfirmed())),
          onCancel: _cache[3] || (_cache[3] = () => { _ctx.templatePendingDelete = null; }),
          msg: _ctx.deleteTemplateConfirmMsg
        }, null, 8, ["msg"]))
      : _createCommentVNode("", true)
  ]))
}